import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Row } from 'react-bootstrap';
const _ = {
    values: require('lodash/values'),
    flatMap: require('lodash/flatMap'),
};
const uuid = require('uuid');

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const FeatureUtil = require('../../../../app/shared/FeatureUtil');

import Navigator from '../../Navigator';
import withSignInStoreState from '../DataHOCs/WithSignInStoreState';
import MainNav from './Menu/MainNav';
import SideMenu from './Menu/SideMenu';
import SlideMenu from './Menu/SlideMenu';
import AuthorDashboard from './AuthorDashboard';
import AuthorInstHome from './AuthorInstHome'
import ExploreDashboard from './ExploreDashboard';
import HelpDashboard from './HelpDashboard';
import StudentCoursesDashboard from './StudentCoursesDashboard';
import StudentAssignmentsDashboard from './StudentAssignmentsDashboard';
import InstructorAssignmentsDashboard from './InstructorAssignmentsDashboard';
import StudentHome from './StudentHome';
import GroupListView from '../dashboard/GroupListView';
import SiteMessageBar from '../dashboard/SiteMessageBar';

const SignInActions = require('../../actions/sign_in_actions');
const LocalAssignmentsStore = require('../../stores/local_assignments_store');
const AssignmentActions = require('../../actions/AssignmentActions');


const propTypes = {
    role: PropTypes.oneOf(_.values(Globals.users.local_role_type)).isRequired,
    history: PropTypes.object.isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            viewTokenDashboard: PropTypes.oneOf(_.values(Globals.view_tokens.dashboard)),
            viewTokenAuthorDashboard: PropTypes.oneOf(_.values(Globals.view_tokens.author_dash)),
            viewTokenChannelDashboard: PropTypes.oneOf(_.values(Globals.view_tokens.author_dash.channel_views)),
            subViewTokenChannelDashboard: PropTypes.oneOf(_.flatMap(Globals.view_tokens.author_dash.channel_subviews, view => _.values(view))),
            channelId: PropTypes.string,
        }).isRequired,
    }).isRequired,
    signInStoreState: PropTypes.shape({
        initializedLocal: PropTypes.bool.isRequired,
        userInfo: PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            display_name: PropTypes.string.isRequired,
        }),
    }).isRequired,
};
const defaultProps = {};

const VIEW_TOKENS = {
    [Globals.users.local_role_type.AUTHOR]: {
        EXPLORE: Globals.view_tokens.dashboard.EXPLORE,
        AUTHORING: Globals.view_tokens.dashboard.AUTHORING,
        HELP: Globals.view_tokens.dashboard.HELP,
    },
    [Globals.users.local_role_type.STUDENT]: {
        COURSES: Globals.view_tokens.dashboard.COURSES,
        ASSIGNMENTS: Globals.view_tokens.dashboard.ASSIGNMENTS,
        HELP: Globals.view_tokens.dashboard.HELP,
    }
};

class DashboardNew extends React.Component {
    constructor(props) {
        super(props);

        // get local assignments 
        let localAssignmentStoreState = LocalAssignmentsStore.getState()
        if (!localAssignmentStoreState.requested) {
            AssignmentActions.getLocalAssignments(uuid.v4());
        }

        this.state = {
            menuVisible: false,
            localAssignmentStoreState,
        };
        this.toggleMenu = this.toggleMenu.bind(this);
        this.hideMenu = this.hideMenu.bind(this);
        
        this.unsubscribes = [
            LocalAssignmentsStore.listen(this.onLocalAssignmentStoreChange)
        ];
    }

    hideMenu() {
        this.setState({ menuVisible: false });
    }

    toggleMenu() {
        this.setState({ menuVisible: !this.state.menuVisible });
    }

    componentDidMount() {
        if (this._isInvalidRoleOrViewToken(this.props.role, this.props.match.params.viewTokenDashboard)) {
            console.error('DashboardNew: Invalid role or view token. Nothing to render.');
        }
        else if (
            !Object.values(VIEW_TOKENS[this.props.role]).indexOf(this.props.match.params.viewTokenDashboard) === -1
        ) {
            console.warn('DashboardNew: Invalid view token for role. Redirecting to base.');
            if (this.props.role === Globals.users.local_role_type.STUDENT) {
                Navigator.goToDashboardStudent(this.props.history);
            }
            else if (this.props.role === Globals.users.local_role_type.AUTHOR) {
                Navigator.goToDashboardAuthor(this.props.history);
            }
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onLocalAssignmentStoreChange=(localAssignmentStoreState)=>{
        this.setState({localAssignmentStoreState});
    }

    _isInvalidRoleOrViewToken(role, viewToken) {
        return (
            Object.values(Globals.users.local_role_type).indexOf(this.props.role) === -1
            || !VIEW_TOKENS[this.props.role]
        );
    }

    render() {
        const viewToken = this.props.match.params.viewTokenDashboard;
        if (this._isInvalidRoleOrViewToken(this.props.role, viewToken)) {
            return null;
        }

        const anyLocalAssignments = this.state.localAssignmentStoreState.localStudentAssignments && (this.state.localAssignmentStoreState.localStudentAssignments.length > 0);
        const anyLocalInstructorAssignments = this.state.localAssignmentStoreState.localAssignments && (this.state.localAssignmentStoreState.localAssignments.length > 0);
        let showSiteMessage = true;

        let actions = [];
        
        if (this.props.role === Globals.users.local_role_type.AUTHOR) {
            actions = actions.concat([
                {
                    id: 0, // unique id for react key
                    iconClass: "fa fa-home",
                    text: Strings['en'].dashboard.HOME,
                    onClick: Navigator.goToDashboardAuthor.bind(this, this.props.history),
                    active: !viewToken,
                },
                {
                    id: 1,
                    text: Strings['en'].dashboard.AUTHOR,
                    //onClick: Navigator.goToDashboardAuthorView.bind(this, this.props.history, Globals.view_tokens.dashboard.AUTHORING)
                    onClick: ()=>{
                        let channelId = this.props.signInStoreState.userInfo.id;
                        Navigator.goToDashboardAuthorAuthoringChannelView(this.props.history, channelId);
                    },
                    active: viewToken === Globals.view_tokens.dashboard.AUTHORING,
                },
                {
                    id: 2,
                    text: Strings['en'].dashboard.SKILLBUILD_STORE,
                    onClick: Navigator.goToDashboardAuthorView.bind(this, this.props.history, Globals.view_tokens.dashboard.EXPLORE),
                    active: viewToken === Globals.view_tokens.dashboard.EXPLORE,
                },
            ]);
            
            if (FeatureUtil.hasGroups(this.props.signInStoreState.userInfo.account_permissions)) {
                actions.push({
                    id: 3,
                    text: Strings['en'].dashboard.GROUPS,
                    onClick: Navigator.goToDashboardAuthorView.bind(this, this.props.history, Globals.view_tokens.dashboard.GROUPS),
                    active: viewToken === Globals.view_tokens.dashboard.GROUPS,
                });
            }
            
            if (anyLocalInstructorAssignments) {
                actions.push({
                    id: 4,
                    iconClass: "fa fa-file-o",
                    text: Strings['en'].dashboard.ASSIGNMENTS,
                    onClick: Navigator.goToDashboardAuthorView.bind(this, this.props.history, Globals.view_tokens.dashboard.ASSN_INSTRUCTOR),
                    active: viewToken === Globals.view_tokens.dashboard.ASSN_INSTRUCTOR,
                });
            }
        }
        else if (this.props.role === Globals.users.local_role_type.STUDENT) {
            actions = actions.concat([
                {
                    id: 0,
                    iconClass: "fa fa-home",
                    text: Strings['en'].dashboard.STUDENT_HOME,
                    onClick: Navigator.goToDashboardStudent.bind(this, this.props.history),
                    active: !viewToken,
                },
                {
                    id: 1,
                    iconClass: "fa fa-list",
                    text: Strings['en'].dashboard.SKILLBUILD_STORE,
                    onClick: Navigator.goToDashboardStudentView.bind(this, this.props.history, Globals.view_tokens.dashboard.COURSES_STUDENT),
                    active: viewToken === Globals.view_tokens.dashboard.COURSES_STUDENT,
                }
            ]);
            if (anyLocalAssignments) {
                actions.push({
                    id: 2,
                    iconClass: "fa fa-file-o",
                    text: Strings['en'].dashboard.ASSIGNMENTS,
                    onClick: Navigator.goToDashboardStudentView.bind(this, this.props.history, Globals.view_tokens.dashboard.ASSN_STUDENT),
                    active: viewToken === Globals.view_tokens.dashboard.ASSN_STUDENT,
                });
            }
        }
        
        let mainContent = null;
        if (this.props.role === Globals.users.local_role_type.AUTHOR) {
            if (viewToken === Globals.view_tokens.dashboard.EXPLORE) {
                showSiteMessage = false;
                mainContent = (
                    <ExploreDashboard
                        userInfo={this.props.signInStoreState.userInfo}
                        role={Globals.users.local_role_type.STUDENT}
                        courseId={this.props.match.params.viewTokenCourseId}
                        gotoExploreRootView={
                            () => Navigator.goToDashboardAuthorExploreCoursesView(this.props.history)
                        }
                        onSelectCourse={
                            (courseId)=>{ Navigator.goToDashboardAuthorPurchaseCourseView(this.props.history, courseId) }
                        }
                        goBack={
                            ()=>{ Navigator.goToDashboardAuthorView(this.props.history, Globals.view_tokens.dashboard.EXPLORE) }
                        }
                    />
                );
            }
            else if (viewToken === Globals.view_tokens.dashboard.AUTHORING) {
                showSiteMessage = false;
                mainContent = (
                    <AuthorDashboard
                        viewToken={this.props.match.params.viewTokenAuthorDashboard}
                        viewTokenChannel={this.props.match.params.viewTokenChannelDashboard}
                        subViewTokenChannel={this.props.match.params.subViewTokenChannelDashboard}
                        channelId={this.props.match.params.channelId}
                    />
                );
            }
            else if (viewToken === Globals.view_tokens.dashboard.GROUPS) {
                mainContent = <GroupListView className="padding-t-15 margin-left-35" />;
            }
            else if (viewToken === Globals.view_tokens.dashboard.HELP) {
                mainContent = <HelpDashboard />;
            }
            else if (viewToken === Globals.view_tokens.dashboard.ASSN_INSTRUCTOR) {
                mainContent = <InstructorAssignmentsDashboard className="padding-t-15 margin-left-35" />;
            }
            else {
                mainContent = <AuthorInstHome className="margin-left-35" history={this.props.history} userInfo={this.props.signInStoreState.userInfo}/>;
            }
        }
        else if (this.props.role === Globals.users.local_role_type.STUDENT) {
            if (viewToken === Globals.view_tokens.dashboard.COURSES_STUDENT) {
                showSiteMessage = false;
                mainContent = (
                    <StudentCoursesDashboard
                        userInfo={this.props.signInStoreState.userInfo}
                        role={Globals.users.local_role_type.STUDENT}
                        courseId={this.props.match.params.viewTokenCourseId}
                        gotoExploreRootView={
                            () => Navigator.goToDashboardStudentExploreCoursesView(this.props.history)
                        }
                        onSelectCourse={
                            (courseId)=>{ Navigator.goToDashboardStudentPurchaseCourseView(this.props.history,courseId) }
                        }
                        goBack={
                            ()=>{ Navigator.goToDashboardStudentView(this.props.history, Globals.view_tokens.dashboard.COURSES_STUDENT) }
                        }
                    />
                );
            }
            else if (viewToken === Globals.view_tokens.dashboard.ASSN_STUDENT) {
                mainContent = <StudentAssignmentsDashboard className="padding-t-15 margin-left-35 padding-r-2rem" />;
            }
            else if (viewToken === Globals.view_tokens.dashboard.HELP) {
                mainContent = <HelpDashboard />;
            }
            else {
                mainContent = <StudentHome className="margin-left-35" history={this.props.history} userInfo={this.props.signInStoreState.userInfo} />;
            }
        }

        return (
            <div className="view-wrapper dashboardNew">
                <MainNav userInfo={this.props.signInStoreState.userInfo} 
                    role={this.props.role}
                    onClickBrandLogo={() => {
                        if (this.props.role === Globals.users.local_role_type.STUDENT) {
                            Navigator.goToDashboardStudent(this.props.history);
                        }
                        else if (this.props.role === Globals.users.local_role_type.AUTHOR) {
                            Navigator.goToDashboardAuthor(this.props.history);
                        }
                    }}
                    onClickAvatar={()=>{Navigator.goToSettings(this.props.history)}}
                >
                    <button
                        className="bare-text-button d-inline-block d-sm-none"
                        onClick={this.toggleMenu}
                    >
                        <span className="fa fa-bars hamburger" aria-hidden={true}/>
                        <span className="sr-only">action menu</span>
                    </button>
                </MainNav>

                <div className="container-fluid main-container main-container--dashboardNew">
                    <Row className="main-content-nav new">
                        <SideMenu
                            actions={actions}
                        />
                        <SlideMenu
                            side="left"
                            visible={this.state.menuVisible}
                            actions={actions}
                            hideMenu={this.hideMenu}
                        />
                        <div className="main-content no-pad">
                            <div className="main-content__content new_content">
                                {(showSiteMessage) && <SiteMessageBar />}
                                {mainContent}
                            </div>
                        </div>
                    </Row>
                </div>
            </div>
        );
    }
}

DashboardNew.propTypes = propTypes;
DashboardNew.defaultProps = defaultProps;

export default withRouter(withSignInStoreState(DashboardNew));